// Archivio "I miei contenuti" — salva un blob generato dal Social Studio
// nell'archivio backend in background. Fire-and-forget: se fallisce, l'utente
// non se ne accorge (il file è già stato scaricato sul telefono).
//
// Backend: routes/social_assets.py · collection `social_assets`.

import { api } from "@/lib/api";

/**
 * @param {Blob} blob - il file generato (PNG, PDF, ZIP…)
 * @param {object} opts
 * @param {string} opts.kind - "post" | "carousel" | "reel" | "story" | "brochure" | "volantino" | "other"
 * @param {string} opts.format - "png" | "pdf" | "zip" | "mp4" | …
 * @param {string} opts.filename - nome del file
 * @param {string} [opts.propertyId]
 * @param {string} [opts.label] - sub-titolo (es. "Nuovo annuncio · Brera")
 * @param {string} [opts.layout]
 * @param {string} [opts.colorPalette]
 * @returns {Promise<object|null>} l'asset salvato o null su errore
 */
export async function archiveAsset(blob, opts) {
  if (!blob || !opts?.kind) return null;
  try {
    const fd = new FormData();
    fd.append("file", blob, opts.filename || `asset.${opts.format || "bin"}`);
    fd.append("kind", opts.kind);
    if (opts.propertyId) fd.append("property_id", opts.propertyId);
    if (opts.label) fd.append("label", opts.label);
    if (opts.layout) fd.append("layout", opts.layout);
    if (opts.colorPalette) fd.append("color_palette", opts.colorPalette);
    const { data } = await api.post("/social-assets", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      // Lungo timeout per Brochure PDF su 4G
      timeout: 30000,
    });
    return data;
  } catch (e) {
    // Silenziosamente: il download locale è già andato a buon fine.
    console.warn("archiveAsset failed (non-blocking):", e?.message || e);
    return null;
  }
}
